module.exports = __webpack_public_path__ + "static/media/youtube.6afb9493.svg";